import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useApi } from "../../../../hooks/useApi";
import LineBtn from "../../../Button/LineBtn";
import DotStatus from "../../../DefaultStyles/DotStatus";
import Loader from "../../../DefaultStyles/Loader";

interface SMSStatusCheckBtnProps {
  messageId: string;
}

export default function SMSStatusCheckBtn({
  messageId,
}: SMSStatusCheckBtnProps) {
  const [checkSms, setCheckSms] = useState(false);

  // sms 상태 조회
  const { response: smsResponse, loading: smsLoading } = useApi({
    method: "post",
    url: checkSms && messageId ? `kakao/lms/${messageId ?? ""}` : undefined,
  });

  console.log(smsResponse);

  useEffect(() => {
    if (smsResponse?.status === 201) {
      if (smsResponse?.data?.result === "") {
        toast.success("확인 중입니다.");
      }

      setCheckSms(false);
    }
  }, [smsResponse]);

  return (
    <>
      {smsResponse && smsResponse?.data?.result !== "" ? (
        <DotStatus
          text={smsResponse?.data?.result === "-100" ? "성공" : "실패"}
          color={smsResponse?.data?.result === "-100" ? "#00c7c7" : "#f42d16"}
          size="sm"
        />
      ) : (
        <LineBtn
          btnText="확인"
          btnClickEvent={() => setCheckSms(true)}
          disabled={smsLoading}
        />
      )}

      {smsLoading && <Loader />}
    </>
  );
}
